import { connect } from 'react-redux'
import { selectIsViaKeyboard } from 'selectors/page'
import Reply from './view'

const select = state => ({
  viaKeyboard: selectIsViaKeyboard(state),
})

export default connect(select)(Reply)
